import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icons, Tooltip } from '@/js/libs/ui/src/V2';
import { PrivateContent, Roles } from '@/js/libs/use-auth';

import { useTranslateModeContext } from 'src/modules/TranslateMode/context.ts';

export const FastTranslateButton = memo(function FastTranslateButton() {
  const [t] = useTranslation(['common']);

  const toggleTranslateMode = useTranslateModeContext('toggleEnabled');
  const isEnabled = useTranslateModeContext('isEnabled');

  const title = `${t('common:FAST_TRANSLATE')}: ${isEnabled ? t('common:ON') : t('common:OFF')}`;

  return (
    <PrivateContent roles={Roles.ADMIN}>
      <Tooltip tooltip={title} placement='top-start'>
        <Button iconOnly ghost onClick={toggleTranslateMode} data-testid='fast-translate-button'>
          <Icons.Translate size={20} />
        </Button>
      </Tooltip>
    </PrivateContent>
  );
});
